import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'flagToIcon'
})
export class FlagToIconPipe implements PipeTransform
{
    transform(flags: string): string
    {
        const splitted = flags ? flags.split('|') : [];

        if (splitted.indexOf('FIRMA_LINK') != -1){
            return 'FIRMA_LINK';
        }

        if (splitted.indexOf('MAIL') != -1){
            return 'MAIL';
        }

        if (splitted.indexOf('SMS') != -1){
            return 'SMS';
        }

        if (splitted.indexOf('WHATSAPP') != -1){
            return 'WHATSAPP';
        }

        return 'MAIL';

    }
}
